module.exports = __webpack_public_path__ + "static/media/TIKTOK.1949245f.png";